import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { baseUrl } from 'src/environments/environment';
import { AllAppointmentsData } from 'src/app/_models/all-appointments.model';
import { PaginatedResponse } from '../_models/response.model';
@Injectable({
  providedIn: 'root',
})
export class AllAppointmentsapi {
  appointmentsUrl =  'api/Appointment';

  constructor(private http: HttpClient) {}

  getAllAppointments(params): Observable<PaginatedResponse<AllAppointmentsData>> {
    return this.http.get<PaginatedResponse<AllAppointmentsData>>(`${this.appointmentsUrl}/GetFilterdAppointments`, {
      params,
    });
  }

  getAllMounjaroAppointments(params): Observable<PaginatedResponse<AllAppointmentsData>> {
    return this.http.get<PaginatedResponse<AllAppointmentsData>>(`${this.appointmentsUrl}/GetFilterPaginatedMounjaroAppointments`, {
      params,
    });
  }

  getLiveAppintments() {
    return this.http.get(`${this.appointmentsUrl}/GetLiveAppointments`);
  }

  getAppointmentById(id): Observable<any> {
    return this.http.get(`${this.appointmentsUrl}/${id}`);
  }

  addProblem(id,isActive,description): Observable<any> {
    return this.http.put(`${this.appointmentsUrl}/HasProblem/${id}/${isActive}`,{});
  }

  reactivate(id): Observable<any> {
    return this.http.put(`${this.appointmentsUrl}/Reactive/${id}`, {});
  }

  refund(id): Observable<any> {
    return this.http.put(`${this.appointmentsUrl}/PatientRefund/${id}`, {});
  }
}
